module.exports = __webpack_public_path__ + "static/trustpilot-retina-107e30b23ce054f69257f2cc1b7f2e07.png";